import { CasesService } from '../services/cases.service'
import { CasesGetListParams, CasesGetListResponse, CasesGetCaseDetailsResponse } from '../types/cases.types'

const casesService = new CasesService()

class CasesRealisation {
    getCases(params: CasesGetListParams): Promise<CasesGetListResponse> {
        return casesService.getCases(params)
    }

    getCase(caseId: number): Promise<CasesGetCaseDetailsResponse> {
        return casesService.getCase(caseId)
    }

    createCase(payload: FormData): Promise<void> {
        return casesService.createCase(payload)
    }

    updateCase(caseId: number, payload: FormData): Promise<void> {
        return casesService.updateCase(caseId, payload)
    }

    deleteCase(caseId: number): Promise<void> {
        return casesService.deleteCase(caseId)
    }
}

export const cases = new CasesRealisation()